import endpoints from 'api/endpoints';
import { normalize } from 'normalizr';
import { topicFaq } from 'schemas';
import Immutable from 'immutable';

export default ({ body, id }) => ({
  url: endpoints.getFaqTopicByIdUrl(id),
  queryKey: `put${endpoints.getFaqTopicByIdUrl()}`,
  transform: response => normalize(response.data, topicFaq.schema).entities,
  body,
  meta: {
    authToken: true,
  },
  force: true,
  options: {
    headers: {
      Accept: 'application/json',
    },
    method: 'PUT',
  },
  update: {
    topicFaq: (prevEntities = Immutable.Map(), nextEntities) => prevEntities.mergeDeep(nextEntities),
  },
});
